export default "__VITE_ASSET__DFx60TE3__"